import { CookingAppliancesState } from './cookingAppliance.types';

import { SelectedApplianceProductType } from '~/core/types/appliances';
import { RootState } from '~/redux/store';

export const selectSuppliedCookingAppliances = ({
  cookingAppliance,
}: RootState): CookingAppliancesState['suppliedCookingAppliances'] =>
  cookingAppliance.suppliedCookingAppliances;

export const selectBrowsedCookingAppliances = ({
  cookingAppliance,
}: RootState): CookingAppliancesState['browsedCookingAppliances'] =>
  cookingAppliance.browsedCookingAppliances;

export const selectSelectedBrowsingOption = ({
  cookingAppliance,
}: RootState): CookingAppliancesState['selectedBrowsingOption'] =>
  cookingAppliance.selectedBrowsingOption;

export const selectSelectedCookingApplianceId = ({
  cookingAppliance,
}: RootState): CookingAppliancesState['selectedCookingApplianceId'] =>
  cookingAppliance.selectedCookingApplianceId;

export const selectSelectedAppliance =
  <T extends SelectedApplianceProductType>(applianceType: T) =>
  ({ cookingAppliance }: RootState): CookingAppliancesState[T] =>
    cookingAppliance[applianceType];
